/*------------------------------------------------*/
/* LIBRARIES
/*------------------------------------------------*/
import _get from 'lodash/get';

/**
 * Sets Workast information (user name, organization, token) about the user in the redux store.
 * We use this to display the user and company name in the integration, as well as to authenticate
 * the user when interacting with the API.
 * @param {Object} state - Redux store state.
 * @param {Object} payload - Set initial data action payload.
 * @param {Object} payload.data - Workast data.
 * @param {String} payload.data.listId - Id of the list this form belongs to.
 * @param {String} payload.data.token - Workast token to identify the user
 * when interacting with the API.
 * @param {Object} payload.data.user - User information, same as retrieved with /user/me endpoint.
 */
const setInitialData = (state, payload) => {
  const {
    data: {
      listId,
      token,
      user
    }
  } = payload;

  const updatedState = state.withMutations((currentState) => {
    const organizationName = _get(user, 'organization.name');
    const userName = _get(user, 'name');
    const teamName = _get(user, 'team.name');

    return currentState
      .set('listId', listId)
      .set('token', token)
      .set('organizationName', organizationName)
      .set('userName', userName)
      .set('teamName', teamName);
  });

  return updatedState;
};

export default {
  setInitialData
};
